import add from './add'
import addButton from './add-button'
import card from './card'
import challengesAndOpportunities from './challenges-and-opportunities'
import deprecationDialog from './deprecation-dialog'
import description from './description'
import details from './details'
import drivers from './drivers'
import evaluation from './evaluation'
import inactive from './inactive'
import industryImpact from './industry-impact'
import insider from './insider'
import list from './list'
import macrotrendDeprecatedTooltip from './macrotrend-deprecated-tooltip'
import megatrendMacrotrends from './megatrend-macrotrends'
import microtrends from './microtrends'
import perception from './perception'
import pinMicroToMacro from './pin-micro-to-macro'
import rating from './rating'
import relatedMacrotrends from './related-macrotrends'
import shareActionButton from './share-action-button'
import subscription from './subscription'
import tabbedContent from './tabbed-content'
import threads from './threads'
import trends from './trends'

export default {
    add,
    addButton,
    card,
    challengesAndOpportunities,
    deprecationDialog,
    description,
    details,
    drivers,
    evaluation,
    inactive,
    industryImpact,
    insider,
    list,
    macrotrendDeprecatedTooltip,
    megatrendMacrotrends,
    microtrends,
    perception,
    pinMicroToMacro,
    rating,
    relatedMacrotrends,
    shareActionButton,
    subscription,
    tabbedContent,
    threads,
    trends
}
